/* Progressive image zoom: native links work when dialog support is unavailable. */
(() => {
  if (window.martenbrownGalleryReady) return;
  window.martenbrownGalleryReady = true;

  const isModifiedClick = (event) => event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  const closeDialog = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    if (isModifiedClick(event)) return;

    const thumbnail = event.target.closest('[data-mb-image]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-mb-gallery]');
      const trigger = gallery?.querySelector('[data-mb-zoom]');
      // Keep the ordinary image link in sync with the existing thumbnail enhancement.
      if (trigger && gallery.querySelector('.mb-main-image')) trigger.href = thumbnail.href;
      return;
    }

    const closeButton = event.target.closest('[data-mb-zoom-close]');
    if (closeButton) {
      closeDialog(closeButton.closest('[data-mb-zoom-dialog]'));
      return;
    }

    const trigger = event.target.closest('[data-mb-zoom]');
    if (!trigger) return;
    const gallery = trigger.closest('[data-mb-gallery]');
    const main = gallery?.querySelector('.mb-main-image');
    const dialog = gallery?.querySelector('[data-mb-zoom-dialog]');
    const imageContainer = dialog?.querySelector('[data-mb-zoom-image]');
    if (!main || !imageContainer || typeof dialog.showModal !== 'function' || dialog.open) return;

    const source = main.getAttribute('src');
    if (!source) return;
    event.preventDefault();
    // Reuse the safe, currently selected image; do not fetch an original-size file.
    const zoomImage = main.cloneNode(false);
    zoomImage.removeAttribute('srcset');
    zoomImage.removeAttribute('sizes');
    zoomImage.removeAttribute('fetchpriority');
    zoomImage.removeAttribute('class');
    zoomImage.setAttribute('loading', 'eager');
    zoomImage.setAttribute('src', source);
    imageContainer.replaceChildren(zoomImage);

    if (!dialog.dataset.mbZoomReady) {
      dialog.dataset.mbZoomReady = 'true';
      dialog.addEventListener('cancel', (cancelEvent) => {
        cancelEvent.preventDefault();
        closeDialog(dialog);
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mb-gallery-zoom-open');
        const opener = dialog.mbZoomOpener;
        if (opener?.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (dialogEvent) => {
        if (dialogEvent.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (dialogEvent.clientX < bounds.left || dialogEvent.clientX > bounds.right || dialogEvent.clientY < bounds.top || dialogEvent.clientY > bounds.bottom) closeDialog(dialog);
      });
    }

    dialog.mbZoomOpener = trigger;
    dialog.showModal();
    document.documentElement.classList.add('mb-gallery-zoom-open');
    dialog.querySelector('[data-mb-zoom-close]').focus({preventScroll: true});
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mb-zoom-dialog][open]').forEach(closeDialog);
  });
})();
